type Listener = () => void;

const subscriptionsToOkRequests: Listener[] = [];

export function subscribeToOkRequests(cb: Listener): () => void {
    subscriptionsToOkRequests.push(cb);

    return (): void => {
        const idx = subscriptionsToOkRequests.indexOf(cb);
        if (idx >= 0) {
            subscriptionsToOkRequests.splice(idx, 1);
        }
    };
}

export function notifyOnOkRequest(r: Response | undefined): void {
    // exclude fake errors
    if (r && r.status !== 0 && r.status < 550) {
        subscriptionsToOkRequests.forEach(subscriber => subscriber());
    }
}
